'use client';
import styled from '@benzinga/themetron';
import { formatPercentage } from '@benzinga/utils';
import React from 'react';

export interface CircularChartProps {
  value: number;
  backgroundColor?: string;
  trackColor?: string;
  indicatorColor?: string;
  disableAnimation?: boolean;
  textColor?: string;
  showPercent?: boolean;
}

export const CircularChart: React.FC<CircularChartProps> = ({
  backgroundColor,
  disableAnimation = false,
  indicatorColor = '#1A79FF',
  showPercent = true,
  textColor = '#000000',
  trackColor,
  value,
}) => {
  const valueAsPercentage = `${value ? formatPercentage(value, true) : '-'}%`;
  return (
    <Container
      $backgroundColor={backgroundColor}
      $disableAnimation={disableAnimation}
      $trackColor={trackColor}
      className="circle-progress-wrapper"
    >
      <svg className="circular-chart" viewBox="0 0 36 36">
        <path
          className="circle-background"
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="circular-chart-indicator"
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
          stroke={indicatorColor}
          strokeDasharray={`${value}, 100`}
        />
        <text className="percentage-text" fill={textColor} x="18" y="20.35">
          {showPercent ? valueAsPercentage : value}
        </text>
      </svg>
    </Container>
  );
};

export default CircularChart;

const Container = styled.div<{ $backgroundColor?: string; $trackColor?: string; $disableAnimation?: boolean }>`
  .circle-background {
    fill: ${({ $backgroundColor }) => $backgroundColor || 'none'};
    stroke: ${({ $trackColor }) => $trackColor || '#eee'};
    stroke-width: 3.8;
  }

  .circular-chart-indicator {
    fill: none;
    stroke-width: 2.8;
    stroke-linecap: round;
    animation: ${({ $disableAnimation }) => ($disableAnimation ? 'unset' : 'progress 1s ease-out forwards')};
  }

  @keyframes progress {
    0% {
      stroke-dasharray: 0 100;
    }
  }

  .percentage-text {
    font-size: 0.5em;
    text-anchor: middle;
  }
`;
